const isBrowser = () => typeof window !== "undefined";

export { isBrowser };
